import { defineStore } from 'pinia'
import { useSyncableModel } from '@/composables/useSyncableModel.js'
import { useApiResource } from '@/composables/resources/useApiResource.js'
import SurveyQuestion from '@/models/SurveyQuestion.js'

export const useSurveyQuestionStore = defineStore('surveyQuestionStore', () => {
  let syncableModel = useSyncableModel(useApiResource('survey_questions'), {
    className: SurveyQuestion.modelName.name,
    paramKey: SurveyQuestion.modelName.paramKey
  })

  function $reset() {
    syncableModel.collection.value = []
  }

  return {
    ...syncableModel,
    $reset
  }

}, {
  persist: true
})
